// 导入axios
import axios from "axios";
import router from "../router";
import { getToken } from "@/utils/cookie.js";
// 使用element-ui Message做消息提醒
import { ElMessage } from "element-plus";
// 1. 创建新的axios实例，
const service = axios.create({
  // 公共接口--开发环境使用代理，生产环境使用API_ROOT
  baseURL: process.env.API_ROOT || "",
  // 超时时间 单位是ms，这里设置了3s的超时时间
  timeout: 200 * 1000,
});
// 2.请求拦截器
service.interceptors.request.use(
  (config) => {
    const token = getToken();

    if (token) {
      // 使用标准的Authorization Bearer格式
      config.headers && (config.headers.Authorization = `Bearer ${token}`);
    }
    // if (localStorage.getItem("Authorization")) {
    //   config.headers.Authorization = localStorage.getItem("Authorization");
    // }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);
// 3.响应拦截器
service.interceptors.response.use(
  (response) => {
    // 接收到响应数据并成功后的一些共有的处理，关闭loading等
    // console.log("response", response.data);
    if (response.data.code === 402) {
      ElMessage.error("未授权，请登录");
      router.push("/login");
    } else if (response.data.code !== 200) {
      ElMessage.error(response.data.message);
    }
    return response.data;
  },
  (error) => {
    // 接收到异常响应的处理开始
    // console.log("error.response", error);
    if (error && error.response) {
      // 1.公共错误处理
      // 2.根据响应码具体处理
      switch (error.response.status) {
        case 400:
          error.message = "错误请求";
          break;
        case 402:
          // localStorage.removeItem("Authorization");
          // sessionStorage.userName = "请登录";
          // localStorage.userName = "请登录";
          window.onbeforeunload = function () {
            var forage = window.localForage;
            // var local = window.localStorage
            var session = window.sessionStorage;
            // local.clear()
            session.clear();
            forage.clear();
          };
          router.push("/login");
          ElMessage.error("未授权，请重新登录");
          break;
        case 403:
          error.message = "拒绝访问";
          break;
        case 404:
          error.message = "请求错误,未找到该资源";
          // window.location.href = "/NotFound"
          break;
        case 405:
          error.message = "请求方法未允许";
          break;
        case 408:
          error.message = "请求超时";
          break;
        case 500:
          error.message = error.response.data.message;
          break;
        case 501:
          error.message = "网络未实现";
          break;
        case 502:
          error.message = "网络错误";
          break;
        case 503:
          error.message = "服务不可用";
          break;
        case 504:
          error.message = "网络超时";
          break;
        case 505:
          error.message = "http版本不支持该请求";
          break;
        default:
          error.message = `连接错误${error.response.status}`;
          break;
      }
    } else {
      // 超时处理
      if (JSON.stringify(error).includes("timeout")) {
        ElMessage.error(" 网络请求无响应，请刷新重试");
      } else {
        error.message = "网络连接失败";
      }
    }
    if (error && error.response && error.response.status !== 401) {
      ElMessage.error(error.message);
    }
    // 处理结束
    // 如果不需要错误处理，以上的处理过程都可省略
    return Promise.resolve(error.response);
  }
);
// 4.导入文件
export default service;
